//
//  src/utils/Hash.js
//


//
//  hash sha256
//
export async function sha256(input) {

    // Handle empty/null/undefined inputs
    if (!input || typeof input !== 'string') {
        return '';
    }

    // Normalize the input: trim whitespace and convert to lowercase
    const normalizedInput = input.trim().toLowerCase();

    // If empty after normalization, return empty string
    if (!normalizedInput) {
        return '';
    }

    // Check if Web Crypto API is available
    if (typeof crypto === 'undefined' || !crypto.subtle) {
        return '';
    }    

    // Try
    try {

        // Encode the normalized input as a Uint8Array
        const encoder = new TextEncoder();
        const data = encoder.encode(normalizedInput);

        // Hash the data using SHA-256
        const hashBuffer = await crypto.subtle.digest('SHA-256', data);

        // Convert the hash to a hexadecimal string
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        const hashHex = hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('');

        // Return
        return hashHex;

    } catch(error) {
        
        // Return
        return '';

    }

}
